import { classNames } from 'libs/react';
import { React } from 'libs/react';
import './Text.scss';
/**
 * @component Text
 * @since 1.0.0
 */
export function Text(props) {
    let { style, value, prefix, suffix, filter, ellipsize, html } = Object.assign({ style: 'normal' }, props);
    const className = classNames('text', 'text--' + style, { 'text--has-prefix': prefix }, { 'text--has-suffix': suffix }, { 'text--has-filter': filter }, { 'text--is-ellipsized': ellipsize }, { 'text--is-html': html }, { 'text--is-clickable': props.onClick }, props.className);
    if (typeof value == 'string' || typeof value == 'number') {
        if (filter) {
            value = filter(value);
        }
    }
    if (html && typeof value == 'string') {
        return (React.createElement("div", { className: className, dangerouslySetInnerHTML: { __html: value }, onClick: props.onClick }));
    }
    return (React.createElement("div", { className: className, onClick: props.onClick },
        prefix,
        value,
        suffix));
}
